import { getQuickReplies } from '@connect-x-app/hybrid-data-access';
import { ApiError, QueryKeys } from '@connect-x-app/shared-domain-models';
import { useQuery } from '@tanstack/react-query';

import { useQuickReplyStore } from '../../stores';

export const useGetQuickReplies = () => {
  const { setQuickReplies } = useQuickReplyStore();

  return useQuery<string[], ApiError, string[]>({
    queryFn: async () => {
      const quickReplies = await getQuickReplies();
      setQuickReplies(quickReplies);
      return quickReplies;
    },
    queryKey: [QueryKeys.QUICK_REPLIES],
  });
};
